<template>
	<resource-form :id="id" type="infographic" plural="infographics" v-model="infographic"></resource-form>
</template>

<script>

import validationRules from "@/util/validation";
import {sync} from "vuex-pathify";
import resourceForm from '@/views/resources/Form'
import models from '@/models'

export default {
	name: "InfographicsForm",
	components: {resourceForm},
	props: ['id'],
	computed: {
		isEdit() {
			return this.$route.meta?.edit
		},
		infographic: sync('infographics/infographic'),
	},
	beforeMount() {
		this.init()
	},
	methods: {
		init() {
			this.$store.set('topics/getTopics!', null)
			if (this.isEdit) {
				this.$store.set('infographics/getInfographic!', this.id)
			} else {
				this.infographic = new models.Resource('Infographic')
			}
		}
	}
}
</script>